import { render, staticRenderFns } from "./Propiedades.vue?vue&type=template&id=f17c2c36&"
import script from "./Propiedades.vue?vue&type=script&lang=js&"
export * from "./Propiedades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports